import React from 'react';

const AssistantContext = React.createContext();

export default AssistantContext;
